import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react'
import type { SortDir } from './topTableSort'

/** Sort affordance shared by the Top merker and Top modeller grids (#586). */
export default function SortIcon({ active, dir }: { active: boolean; dir: SortDir }) {
  if (!active) return <ChevronsUpDown className="w-3.5 h-3.5 inline ml-1 opacity-40" />
  return dir === 'asc'
    ? <ArrowUp className="w-3.5 h-3.5 inline ml-1" />
    : <ArrowDown className="w-3.5 h-3.5 inline ml-1" />
}
